import ConferenceBrowser from "./Browser";

export default function AllEvents() {
    return <ConferenceBrowser />;
}
